(function () {
    'use strict';

    angular.module('elogbooks.admin.client-billing', []);
})();
